import React from 'react';
import { Pagination as AntPagination } from 'antd';
import { PaginationProps } from 'antd/lib/pagination';

import cn from 'classnames';

import styles from './Pagination.module.scss';

export interface IPaginationProps extends PaginationProps {}

/**
 * Pagination component
 */
export const Pagination: React.FC<IPaginationProps> = ({
  className,
  ...props
}) => {
  return (
    <AntPagination className={(cn(styles.Pagination), className)} {...props} />
  );
};
